module.exports = __webpack_public_path__ + "img/21000.2d0457ad.jpg";